// extracted by mini-css-extract-plugin
export default {"roundedButtonWhite":"RoundedButton_roundedButtonWhite__GG99x","roundedButtonBlue":"RoundedButton_roundedButtonBlue__PvYJl"};